module.exports = __webpack_public_path__ + "static/media/couple-bracelet_720x480.c30a6b1e.jpg";